<!--
Book - theres not much more to it :)
@author ab557z
-->

<template>
  <div class="bookDiv">
    <p class="bookTitleText">{{ title }}</p>
    <p class="bookAuthorText">{{ author }}</p>
    <p class="bookInfo">
      <span class="bookTitleText">{{ dateLead() }}</span>
      <span class="bookDateText">{{ humanDate(date) }}</span>
      <span v-if="shortLoan" class="bookTimeText"> {{ humanTime(date) }}</span>
      <img
        style="position: absolute; right: 20px;"
        :src="imageDecision()"
      />
    </p>
    <p v-if="holdLocation" class="holdLocation">
        <font-awesome-icon class="holdLocationImg" icon="map-marker-alt" /> {{ holdLocation }}
    </p>
  </div>
</template>

<script setup>
import Overdue from '@/assets/library/overdue.png'
import Available from '@/assets/library/available.png'

const props = defineProps ({
  title: String,
  author: String,
  typeOfDate: String,
  date: Number,
  holdLocation: String,
  shortLoan: Boolean
})

  function dateLead () {
    if (props.typeOfDate == 'Available') {
      return 'Available on'
    } else {
      return 'Due date'
    }
  }

  function humanTime (d) {
    const timeOptions = {
      hour: '2-digit',
      minute: '2-digit'
    }

    const dateReady = new Date(d)
    const ret = dateReady.toLocaleTimeString('en-GB', timeOptions)
    return ret
  }

  function humanDate (d) {
    const options = {
      weekday: 'short',
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    }

    const dateReady = new Date(d)
    const ret = dateReady.toLocaleDateString('en-GB', options)
    return ret
  }

  // proof i can write clean code.. instead of 20 lines, have 4 !
  function imageDecision () {
    let cur = new Date()
    // so if current time is bigger, its either overdue or the book has become available. magic !
    if (props.date < cur) {
      return props.typeOfDate == 'Due' ? Overdue : Available
    }
    return undefined
  }


</script>
<style lang="scss" scoped>
.bookDateText {
  font-family: "PTSans";
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #4f5961;
  margin-left: 12px;
}
.bookTimeText {
  font-family: "PTSans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: #4f5961;
  margin-left: 12px;
}
.bookInfo {
  margin-bottom: 0px;
  margin-top: 0px;
}
.bookDiv {
  padding-left: 24px;
  padding-right: 24px;
  padding-top: 18px;
  padding-bottom: 18px;
  position: relative;
  border-bottom: 1px solid #e4e4e4;
}
.bookAuthorText {
  font-family: "PTSans";
  font-style: normal;
  font-weight: 400;
  margin-top: 8px;
  margin-bottom: 20px;
  font-size: 14px;
  line-height: 18px;
  color: #003865;
}

.bookTitleText {
  font-family: "PTSans";
  font-style: normal;
  font-weight: 700;
  margin-bottom: 0px;
  margin-top: 0px;
  font-size: 16px;
  line-height: 21px;
  color: #003865;
}
.holdLocation {
  font-size: 14px;
  margin-top: 5px;
}
</style>
